module.exports = __webpack_public_path__ + "Roboto-Bold.39b2c3031be6b4ea96e2.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Bold.woff2
// module id = ../../../../../font/roboto/Roboto-Bold.woff2
// module chunks = styles